/* @flow */
import invariant from 'invariant';
import * as React from 'react';

import Dialog from 'components/Dialog';
import Table from 'components/Table';
import OrgRoleDropdown from 'groups/components/OrgRoleDropdown';
import UsersAvatarWithText from 'users/components/UsersAvatarWithText';

import type { PotentialRole } from 'groups/components/OrgRoleDropdown';
import type { UnsafePartialUser } from 'users/components/UserAvatar';
import type { OrganizationRole } from 'queries/__generated__/globalGQLTypes';

import './styles/BatchRoleCorrectionModal.scss';

type UserData = {
  orgAffiliationView: {
    can_have_role_changed: boolean,
    roles: OrganizationRole[],
    potential_roles: PotentialRole[],
  },
  user: UnsafePartialUser & {
    +id: Backbone$Id,
  },
};

export type Props = {
  loading?: boolean,
  onClose?: ?Function,
  onRequestHide?: () => any, // From mountModal
  onUserRoleSave?: (userId: number) => any,
  organizationId: number,
  userData: UserData[],
};

export default class BatchRoleCorrectionModalCommon extends React.Component<Props> {
  componentWillUnmount() {
    const { onClose } = this.props;

    if (onClose) {
      onClose();
    }
  }

  renderMemberRow(userData: UserData) {
    const { onUserRoleSave, organizationId } = this.props;
    const { user, orgAffiliationView } = userData;
    invariant(orgAffiliationView, 'member missing org_affiliation_view');

    return (
      <tr key={user.id}>
        <td>
          <UsersAvatarWithText subtle user={user} />
        </td>
        <td>
          <OrgRoleDropdown
            canHaveRoleChanged={orgAffiliationView.can_have_role_changed}
            initialRoles={orgAffiliationView.roles}
            onFinishSave={onUserRoleSave}
            organizationId={organizationId}
            potentialRoles={orgAffiliationView.potential_roles}
            userId={user.id}
          />
        </td>
      </tr>
    );
  }

  render() {
    const { loading, onRequestHide, userData } = this.props;

    return (
      <Dialog
        title="Modify roles"
        className="BatchRoleCorrectionModal"
        eventScreenName="BatchRoleCorrectionModal"
        onRequestHide={onRequestHide}>
        <div className="BatchRoleCorrectionModal-body">
          <Table
            fixedHeader
            head={
              <tr>
                <th>Name</th>
                <th>Role</th>
              </tr>
            }
            loading={loading}
            className="BatchRoleCorrectionModal-table">
            <tbody>{userData.map(m => this.renderMemberRow(m))}</tbody>
          </Table>
        </div>
      </Dialog>
    );
  }
}
